/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  AddressBaseDTO,
  AddressBaseDTOOptional,
  AddressBaseDTOMetaI,
  AddressBaseDTOTrackedI,
} from "./address-base-dto";
import { AddressBaseDTOTracked, AddressBaseDTOMeta } from "./address-base-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  CountryCode,
  CountryCodeOptional,
  CountryCodeMetaI,
  CountryCodeTrackedI,
} from "./country-code";
import { CountryCodeTracked, CountryCodeMeta } from "./country-code";
// May contain unused imports in some cases
// @ts-ignore
import type {
  Deletable,
  DeletableOptional,
  DeletableMetaI,
  DeletableTrackedI,
} from "./deletable";
import { DeletableTracked, DeletableMeta } from "./deletable";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PersonAddressBase,
  PersonAddressBaseOptional,
  PersonAddressBaseMetaI,
  PersonAddressBaseTrackedI,
} from "./person-address-base";
import {
  PersonAddressBaseTracked,
  PersonAddressBaseMeta,
} from "./person-address-base";
// May contain unused imports in some cases
// @ts-ignore
import type {
  USStateCode,
  USStateCodeOptional,
  USStateCodeMetaI,
  USStateCodeTrackedI,
} from "./usstate-code";
import { USStateCodeTracked, USStateCodeMeta } from "./usstate-code";

/**
 *
 * @export
 * @interface AddressDTO
 */
export interface AddressDTOOptional extends AddressBaseDTOOptional {
  /**
   *
   * @type {boolean}
   * @memberof AddressDTO
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof AddressDTO
   */
  isNew?: boolean;
  /**
   *
   * @type {string}
   * @memberof AddressDTO
   */
  line1?: string;
  /**
   *
   * @type {string}
   * @memberof AddressDTO
   */
  line2?: string;
  /**
   *
   * @type {string}
   * @memberof AddressDTO
   */
  line3?: string;
  /**
   *
   * @type {USStateCode}
   * @memberof AddressDTO
   */
  state?: USStateCode;
  /**
   *
   * @type {string}
   * @memberof AddressDTO
   */
  city?: string;
  /**
   *
   * @type {CountryCode}
   * @memberof AddressDTO
   */
  country?: CountryCode;
  /**
   *
   * @type {string}
   * @memberof AddressDTO
   */
  zip?: string;
  /**
   *
   * @type {boolean}
   * @memberof AddressDTO
   */
  isVerified?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof AddressDTO
   */
  isBad?: boolean;
  /**
   *
   * @type {number}
   * @memberof AddressDTO
   */
  assignId?: number;
  /**
   *
   * @type {number}
   * @memberof AddressDTO
   */
  personAddressAssignId?: number;
  /**
   *
   * @type {string}
   * @memberof AddressDTO
   */
  startActive?: Date;
  /**
   *
   * @type {string}
   * @memberof AddressDTO
   */
  endActive?: Date;
  /**
   *
   * @type {string}
   * @memberof AddressDTO
   */
  name?: string;
  /**
   *
   * @type {boolean}
   * @memberof AddressDTO
   */
  isPrimary?: boolean;
}

export interface AddressDTO
  extends AddressDTOOptional, AddressBaseDTO, Deletable, PersonAddressBase {
  /**
   *
   * @type {boolean}
   * @memberof AddressDTO
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof AddressDTO
   */
  isNew?: boolean;
  /**
   *
   * @type {string}
   * @memberof AddressDTO
   */
  line1: string;
  /**
   *
   * @type {string}
   * @memberof AddressDTO
   */
  line2?: string;
  /**
   *
   * @type {string}
   * @memberof AddressDTO
   */
  line3?: string;
  /**
   *
   * @type {USStateCode}
   * @memberof AddressDTO
   */
  state?: USStateCode;
  /**
   *
   * @type {string}
   * @memberof AddressDTO
   */
  city?: string;
  /**
   *
   * @type {CountryCode}
   * @memberof AddressDTO
   */
  country: CountryCode;
  /**
   *
   * @type {string}
   * @memberof AddressDTO
   */
  zip?: string;
  /**
   *
   * @type {boolean}
   * @memberof AddressDTO
   */
  isVerified?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof AddressDTO
   */
  isBad?: boolean;
  /**
   *
   * @type {number}
   * @memberof AddressDTO
   */
  assignId: number;
  /**
   *
   * @type {number}
   * @memberof AddressDTO
   */
  personAddressAssignId: number;
  /**
   *
   * @type {string}
   * @memberof AddressDTO
   */
  startActive?: Date;
  /**
   *
   * @type {string}
   * @memberof AddressDTO
   */
  endActive?: Date;
  /**
   *
   * @type {string}
   * @memberof AddressDTO
   */
  name?: string;
  /**
   *
   * @type {boolean}
   * @memberof AddressDTO
   */
  isPrimary?: boolean;
}

export interface AddressDTOTrackedI extends AddressBaseDTOOptional {
  /**
   *
   * @type {boolean}
   * @memberof AddressDTO
   */
  isDeleted?: boolean;
  isDeletedIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof AddressDTO
   */
  isNew?: boolean;
  isNewIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof AddressDTO
   */
  line1?: string;
  line1IsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof AddressDTO
   */
  line2?: string;
  line2IsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof AddressDTO
   */
  line3?: string;
  line3IsSet: boolean;
  /**
   *
   * @type {USStateCode}
   * @memberof AddressDTO
   */
  state?: USStateCode;
  stateIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof AddressDTO
   */
  city?: string;
  cityIsSet: boolean;
  /**
   *
   * @type {CountryCode}
   * @memberof AddressDTO
   */
  country?: CountryCode;
  countryIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof AddressDTO
   */
  zip?: string;
  zipIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof AddressDTO
   */
  isVerified?: boolean;
  isVerifiedIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof AddressDTO
   */
  isBad?: boolean;
  isBadIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof AddressDTO
   */
  assignId?: number;
  assignIdIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof AddressDTO
   */
  personAddressAssignId?: number;
  personAddressAssignIdIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof AddressDTO
   */
  startActive?: Date;
  startActiveIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof AddressDTO
   */
  endActive?: Date;
  endActiveIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof AddressDTO
   */
  name?: string;
  nameIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof AddressDTO
   */
  isPrimary?: boolean;
  isPrimaryIsSet: boolean;
}

transformDatesMap.set("AddressDTO", function (model: AddressDTO) {
  if (typeof model.startActive == "string")
    model.startActive = new Date(model.startActive);
  if (typeof model.endActive == "string")
    model.endActive = new Date(model.endActive);
});

export type AddressDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  isDeleted: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  isNew: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  line1: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  line2: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  line3: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  state: PropertyMeta<USStateCodeMetaI>;
  //isDate: false
  //isDatetime: false
  city: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  country: PropertyMeta<CountryCodeMetaI>;
  //isDate: false
  //isDatetime: false
  zip: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  isVerified: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  isBad: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  assignId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  personAddressAssignId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: true
  startActive: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: true
  endActive: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  name: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  isPrimary: PropertyMeta<MetaTypeBase<boolean>>;
}>;

export var AddressDTOMeta: AddressDTOMetaI = {} as AddressDTOMetaI;
AddressDTOMeta = typeMeta("AddressDTO", {
  isDeleted: propertyMeta(
    "isDeleted",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  isNew: propertyMeta("isNew", false, false, false, MetaTypesBase.boolean),
  line1: propertyMeta("line1", false, true, false, MetaTypesBase.string),
  line2: propertyMeta("line2", false, false, false, MetaTypesBase.string),
  line3: propertyMeta("line3", false, false, false, MetaTypesBase.string),
  state: propertyMeta("state", false, false, false, USStateCodeMeta),
  city: propertyMeta("city", false, false, false, MetaTypesBase.string),
  country: propertyMeta("country", false, true, false, CountryCodeMeta),
  zip: propertyMeta("zip", false, false, false, MetaTypesBase.string),
  isVerified: propertyMeta(
    "isVerified",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  isBad: propertyMeta("isBad", false, false, false, MetaTypesBase.boolean),
  assignId: propertyMeta("assignId", false, true, true, MetaTypesBase.number),
  personAddressAssignId: propertyMeta(
    "personAddressAssignId",
    false,
    true,
    true,
    MetaTypesBase.number,
  ),
  startActive: propertyMeta(
    "startActive",
    false,
    false,
    false,
    MetaTypesBase.Date,
  ),
  endActive: propertyMeta("endActive", false, false, false, MetaTypesBase.Date),
  name: propertyMeta("name", false, false, false, MetaTypesBase.string),
  isPrimary: propertyMeta(
    "isPrimary",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
});

const metaI = AddressDTOMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([AddressBaseDTOMeta]);
  metaI.isDeleted.inheritedFrom = AddressBaseDTOMeta.isDeleted;
  metaI.isNew.inheritedFrom = AddressBaseDTOMeta.isNew;
  metaI.line1.inheritedFrom = AddressBaseDTOMeta.line1;
  metaI.line2.inheritedFrom = AddressBaseDTOMeta.line2;
  metaI.line3.inheritedFrom = AddressBaseDTOMeta.line3;
  metaI.state.inheritedFrom = AddressBaseDTOMeta.state;
  metaI.city.inheritedFrom = AddressBaseDTOMeta.city;
  metaI.country.inheritedFrom = AddressBaseDTOMeta.country;
  metaI.zip.inheritedFrom = AddressBaseDTOMeta.zip;
  metaI.isVerified.inheritedFrom = AddressBaseDTOMeta.isVerified;
  metaI.isBad.inheritedFrom = AddressBaseDTOMeta.isBad;
  metaI.assignId.inheritedFrom = AddressBaseDTOMeta.assignId;
  metaI.interfaces = metaI.interfaces.concat([PersonAddressBaseMeta]);
  metaI.personAddressAssignId.inheritedFrom =
    PersonAddressBaseMeta.personAddressAssignId;
  metaI.startActive.inheritedFrom = PersonAddressBaseMeta.startActive;
  metaI.endActive.inheritedFrom = PersonAddressBaseMeta.endActive;
  metaI.name.inheritedFrom = PersonAddressBaseMeta.name;
  metaI.isPrimary.inheritedFrom = PersonAddressBaseMeta.isPrimary;
  metaI.interfaces = metaI.interfaces.concat([DeletableMeta]);
  metaI.isDeleted.inheritedFrom = DeletableMeta.isDeleted;
  metaI.isNew.inheritedFrom = DeletableMeta.isNew;
});

export class AddressDTOTracked
  extends AddressBaseDTOTracked
  implements AddressDTOTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  isDeleted__I?: boolean = undefined;
  isDeletedIsSet: boolean = false;
  set isDeleted(v: undefined | boolean) {
    if (v !== undefined) {
      this.isDeleted__I = v;
      this.isDeletedIsSet = true;
    } else {
      this.isDeleted__I = v || undefined;
      this.isDeletedIsSet = false;
    }
    this.changeTracker = true;
  }
  get isDeleted() {
    return this.isDeleted__I;
  }
  isNew__I?: boolean = undefined;
  isNewIsSet: boolean = false;
  set isNew(v: undefined | boolean) {
    if (v !== undefined) {
      this.isNew__I = v;
      this.isNewIsSet = true;
    } else {
      this.isNew__I = v || undefined;
      this.isNewIsSet = false;
    }
    this.changeTracker = true;
  }
  get isNew() {
    return this.isNew__I;
  }
  line1__I?: string = undefined;
  line1IsSet: boolean = false;
  set line1(v: undefined | string) {
    if (v !== undefined) {
      this.line1__I = v;
      this.line1IsSet = true;
    } else {
      this.line1__I = v || undefined;
      this.line1IsSet = true;
    }
    this.changeTracker = true;
  }
  get line1() {
    return this.line1__I;
  }
  line2__I?: string = undefined;
  line2IsSet: boolean = false;
  set line2(v: undefined | string) {
    if (v !== undefined) {
      this.line2__I = v;
      this.line2IsSet = true;
    } else {
      this.line2__I = v || undefined;
      this.line2IsSet = false;
    }
    this.changeTracker = true;
  }
  get line2() {
    return this.line2__I;
  }
  line3__I?: string = undefined;
  line3IsSet: boolean = false;
  set line3(v: undefined | string) {
    if (v !== undefined) {
      this.line3__I = v;
      this.line3IsSet = true;
    } else {
      this.line3__I = v || undefined;
      this.line3IsSet = false;
    }
    this.changeTracker = true;
  }
  get line3() {
    return this.line3__I;
  }
  state__I?: USStateCode = undefined;
  stateIsSet: boolean = false;
  set state(v: undefined | USStateCode) {
    if (v !== undefined) {
      this.state__I = v;
      this.stateIsSet = true;
    } else {
      this.state__I = v || undefined;
      this.stateIsSet = false;
    }
    this.changeTracker = true;
  }
  get state() {
    return this.state__I;
  }
  city__I?: string = undefined;
  cityIsSet: boolean = false;
  set city(v: undefined | string) {
    if (v !== undefined) {
      this.city__I = v;
      this.cityIsSet = true;
    } else {
      this.city__I = v || undefined;
      this.cityIsSet = false;
    }
    this.changeTracker = true;
  }
  get city() {
    return this.city__I;
  }
  country__I?: CountryCode = undefined;
  countryIsSet: boolean = false;
  set country(v: undefined | CountryCode) {
    if (v !== undefined) {
      this.country__I = v;
      this.countryIsSet = true;
    } else {
      this.country__I = v || undefined;
      this.countryIsSet = true;
    }
    this.changeTracker = true;
  }
  get country() {
    return this.country__I;
  }
  zip__I?: string = undefined;
  zipIsSet: boolean = false;
  set zip(v: undefined | string) {
    if (v !== undefined) {
      this.zip__I = v;
      this.zipIsSet = true;
    } else {
      this.zip__I = v || undefined;
      this.zipIsSet = false;
    }
    this.changeTracker = true;
  }
  get zip() {
    return this.zip__I;
  }
  isVerified__I?: boolean = undefined;
  isVerifiedIsSet: boolean = false;
  set isVerified(v: undefined | boolean) {
    if (v !== undefined) {
      this.isVerified__I = v;
      this.isVerifiedIsSet = true;
    } else {
      this.isVerified__I = v || undefined;
      this.isVerifiedIsSet = false;
    }
    this.changeTracker = true;
  }
  get isVerified() {
    return this.isVerified__I;
  }
  isBad__I?: boolean = undefined;
  isBadIsSet: boolean = false;
  set isBad(v: undefined | boolean) {
    if (v !== undefined) {
      this.isBad__I = v;
      this.isBadIsSet = true;
    } else {
      this.isBad__I = v || undefined;
      this.isBadIsSet = false;
    }
    this.changeTracker = true;
  }
  get isBad() {
    return this.isBad__I;
  }
  assignId__I?: number = undefined;

  get assignIdIsSet() {
    return this.assignId !== undefined;
  }
  set assignIdIsSet(v: boolean) {}
  set assignId(v: undefined | number) {
    if (v !== undefined) {
      this.assignId__I = v;
      this.assignIdIsSet = true;
    } else {
      this.assignId__I = v || undefined;
      this.assignIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get assignId() {
    return this.assignId__I;
  }
  personAddressAssignId__I?: number = undefined;

  get personAddressAssignIdIsSet() {
    return this.personAddressAssignId !== undefined;
  }
  set personAddressAssignIdIsSet(v: boolean) {}
  set personAddressAssignId(v: undefined | number) {
    if (v !== undefined) {
      this.personAddressAssignId__I = v;
      this.personAddressAssignIdIsSet = true;
    } else {
      this.personAddressAssignId__I = v || undefined;
      this.personAddressAssignIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get personAddressAssignId() {
    return this.personAddressAssignId__I;
  }
  startActive__I?: Date = undefined;
  startActiveIsSet: boolean = false;
  set startActive(v: undefined | Date) {
    if (v !== undefined) {
      this.startActive__I = v;
      this.startActiveIsSet = true;
    } else {
      this.startActive__I = v || undefined;
      this.startActiveIsSet = false;
    }
    this.changeTracker = true;
  }
  get startActive() {
    return this.startActive__I;
  }
  endActive__I?: Date = undefined;
  endActiveIsSet: boolean = false;
  set endActive(v: undefined | Date) {
    if (v !== undefined) {
      this.endActive__I = v;
      this.endActiveIsSet = true;
    } else {
      this.endActive__I = v || undefined;
      this.endActiveIsSet = false;
    }
    this.changeTracker = true;
  }
  get endActive() {
    return this.endActive__I;
  }
  name__I?: string = undefined;
  nameIsSet: boolean = false;
  set name(v: undefined | string) {
    if (v !== undefined) {
      this.name__I = v;
      this.nameIsSet = true;
    } else {
      this.name__I = v || undefined;
      this.nameIsSet = false;
    }
    this.changeTracker = true;
  }
  get name() {
    return this.name__I;
  }
  isPrimary__I?: boolean = undefined;
  isPrimaryIsSet: boolean = false;
  set isPrimary(v: undefined | boolean) {
    if (v !== undefined) {
      this.isPrimary__I = v;
      this.isPrimaryIsSet = true;
    } else {
      this.isPrimary__I = v || undefined;
      this.isPrimaryIsSet = false;
    }
    this.changeTracker = true;
  }
  get isPrimary() {
    return this.isPrimary__I;
  }
  constructor(config?: AddressDTOOptional, options?: AssignOptions) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.assignIdIsSet == true && other?.assignIdIsSet == true)
      return this.assignId == other.assignId;
    if (
      this.personAddressAssignIdIsSet == true &&
      other?.personAddressAssignIdIsSet == true
    )
      return this.personAddressAssignId == other.personAddressAssignId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.assignId) {
      this.assignIdIsSet = true;
    }

    if (this.anySet() && !!this.personAddressAssignId) {
      this.personAddressAssignIdIsSet = true;
    }
  }
  assignFrom(
    config: AddressDTOOptional,
    options?: AssignOptions,
  ): AddressDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.isDeleted && this.isDeletedApplyFilter(optionsRequired.filter)) {
      this.isDeleted = config.isDeleted;
      if (optionsRequired.unassign) this.isDeletedIsSet = false;
      else this.isDeletedIsSet = true;
    }
    if (config.isNew && this.isNewApplyFilter(optionsRequired.filter)) {
      this.isNew = config.isNew;
      if (optionsRequired.unassign) this.isNewIsSet = false;
      else this.isNewIsSet = true;
    }
    if (config.line1 && this.line1ApplyFilter(optionsRequired.filter)) {
      this.line1 = config.line1;
      if (optionsRequired.unassign) this.line1IsSet = false;
      else this.line1IsSet = true;
    }
    if (config.line2 && this.line2ApplyFilter(optionsRequired.filter)) {
      this.line2 = config.line2;
      if (optionsRequired.unassign) this.line2IsSet = false;
      else this.line2IsSet = true;
    }
    if (config.line3 && this.line3ApplyFilter(optionsRequired.filter)) {
      this.line3 = config.line3;
      if (optionsRequired.unassign) this.line3IsSet = false;
      else this.line3IsSet = true;
    }
    if (config.state && this.stateApplyFilter(optionsRequired.filter)) {
      this.state = config.state;
      if (optionsRequired.unassign) this.stateIsSet = false;
      else this.stateIsSet = true;
    }
    if (config.city && this.cityApplyFilter(optionsRequired.filter)) {
      this.city = config.city;
      if (optionsRequired.unassign) this.cityIsSet = false;
      else this.cityIsSet = true;
    }
    if (config.country && this.countryApplyFilter(optionsRequired.filter)) {
      this.country = config.country;
      if (optionsRequired.unassign) this.countryIsSet = false;
      else this.countryIsSet = true;
    }
    if (config.zip && this.zipApplyFilter(optionsRequired.filter)) {
      this.zip = config.zip;
      if (optionsRequired.unassign) this.zipIsSet = false;
      else this.zipIsSet = true;
    }
    if (
      config.isVerified &&
      this.isVerifiedApplyFilter(optionsRequired.filter)
    ) {
      this.isVerified = config.isVerified;
      if (optionsRequired.unassign) this.isVerifiedIsSet = false;
      else this.isVerifiedIsSet = true;
    }
    if (config.isBad && this.isBadApplyFilter(optionsRequired.filter)) {
      this.isBad = config.isBad;
      if (optionsRequired.unassign) this.isBadIsSet = false;
      else this.isBadIsSet = true;
    }
    if (config.assignId && this.assignIdApplyFilter(optionsRequired.filter)) {
      this.assignId = config.assignId;
      if (optionsRequired.unassign) this.assignIdIsSet = false;
      else this.assignIdIsSet = true;
    }
    if (
      config.personAddressAssignId &&
      this.personAddressAssignIdApplyFilter(optionsRequired.filter)
    ) {
      this.personAddressAssignId = config.personAddressAssignId;
      if (optionsRequired.unassign) this.personAddressAssignIdIsSet = false;
      else this.personAddressAssignIdIsSet = true;
    }
    if (
      config.startActive &&
      this.startActiveApplyFilter(optionsRequired.filter)
    ) {
      this.startActive = config.startActive;
      if (optionsRequired.unassign) this.startActiveIsSet = false;
      else this.startActiveIsSet = true;
    }
    if (config.endActive && this.endActiveApplyFilter(optionsRequired.filter)) {
      this.endActive = config.endActive;
      if (optionsRequired.unassign) this.endActiveIsSet = false;
      else this.endActiveIsSet = true;
    }
    if (config.name && this.nameApplyFilter(optionsRequired.filter)) {
      this.name = config.name;
      if (optionsRequired.unassign) this.nameIsSet = false;
      else this.nameIsSet = true;
    }
    if (config.isPrimary && this.isPrimaryApplyFilter(optionsRequired.filter)) {
      this.isPrimary = config.isPrimary;
      if (optionsRequired.unassign) this.isPrimaryIsSet = false;
      else this.isPrimaryIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): AddressDTOTrackedI {
    const cloned = {} as AddressDTOTrackedI;
    if (
      this.isDeletedIsSetDeep() &&
      this.isDeletedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isDeletedIsSet = true;
      cloned.isDeleted = this.isDeleted;
    } else {
      //cloned.isDeletedIsSet = false
    }
    if (
      this.isNewIsSetDeep() &&
      this.isNewApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isNewIsSet = true;
      cloned.isNew = this.isNew;
    } else {
      //cloned.isNewIsSet = false
    }
    if (
      this.line1IsSetDeep() &&
      this.line1ApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.line1IsSet = true;
      cloned.line1 = this.line1;
    } else {
      //cloned.line1IsSet = false
    }
    if (
      this.line2IsSetDeep() &&
      this.line2ApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.line2IsSet = true;
      cloned.line2 = this.line2;
    } else {
      //cloned.line2IsSet = false
    }
    if (
      this.line3IsSetDeep() &&
      this.line3ApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.line3IsSet = true;
      cloned.line3 = this.line3;
    } else {
      //cloned.line3IsSet = false
    }
    if (
      this.stateIsSetDeep() &&
      this.stateApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.stateIsSet = true;
      cloned.state = this.state;
    } else {
      //cloned.stateIsSet = false
    }
    if (
      this.cityIsSetDeep() &&
      this.cityApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.cityIsSet = true;
      cloned.city = this.city;
    } else {
      //cloned.cityIsSet = false
    }
    if (
      this.countryIsSetDeep() &&
      this.countryApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.countryIsSet = true;
      cloned.country = this.country;
    } else {
      //cloned.countryIsSet = false
    }
    if (
      this.zipIsSetDeep() &&
      this.zipApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.zipIsSet = true;
      cloned.zip = this.zip;
    } else {
      //cloned.zipIsSet = false
    }
    if (
      this.isVerifiedIsSetDeep() &&
      this.isVerifiedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isVerifiedIsSet = true;
      cloned.isVerified = this.isVerified;
    } else {
      //cloned.isVerifiedIsSet = false
    }
    if (
      this.isBadIsSetDeep() &&
      this.isBadApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isBadIsSet = true;
      cloned.isBad = this.isBad;
    } else {
      //cloned.isBadIsSet = false
    }
    if (
      this.assignIdIsSetDeep() &&
      this.assignIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.assignIdIsSet = true;
      cloned.assignId = this.assignId;
    } else {
      //cloned.assignIdIsSet = false
    }
    if (
      this.personAddressAssignIdIsSetDeep() &&
      this.personAddressAssignIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.personAddressAssignIdIsSet = true;
      cloned.personAddressAssignId = this.personAddressAssignId;
    } else {
      //cloned.personAddressAssignIdIsSet = false
    }
    if (
      this.startActiveIsSetDeep() &&
      this.startActiveApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.startActiveIsSet = true;
      cloned.startActive = this.startActive;
    } else {
      //cloned.startActiveIsSet = false
    }
    if (
      this.endActiveIsSetDeep() &&
      this.endActiveApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.endActiveIsSet = true;
      cloned.endActive = this.endActive;
    } else {
      //cloned.endActiveIsSet = false
    }
    if (
      this.nameIsSetDeep() &&
      this.nameApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.nameIsSet = true;
      cloned.name = this.name;
    } else {
      //cloned.nameIsSet = false
    }
    if (
      this.isPrimaryIsSetDeep() &&
      this.isPrimaryApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isPrimaryIsSet = true;
      cloned.isPrimary = this.isPrimary;
    } else {
      //cloned.isPrimaryIsSet = false
    }
    if (!isDeleted(this) && !this.assignIdIsSet) updateIsNew(cloned, true);
    if (!isDeleted(this) && !this.personAddressAssignIdIsSet)
      updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): AddressDTOTrackedI {
    if (!this.isDeletedApplyFilter(filter)) this.isDeletedIsSet = false;

    if (!this.isNewApplyFilter(filter)) this.isNewIsSet = false;

    if (!this.line1ApplyFilter(filter)) this.line1IsSet = false;

    if (!this.line2ApplyFilter(filter)) this.line2IsSet = false;

    if (!this.line3ApplyFilter(filter)) this.line3IsSet = false;

    if (!this.stateApplyFilter(filter)) this.stateIsSet = false;

    if (!this.cityApplyFilter(filter)) this.cityIsSet = false;

    if (!this.countryApplyFilter(filter)) this.countryIsSet = false;

    if (!this.zipApplyFilter(filter)) this.zipIsSet = false;

    if (!this.isVerifiedApplyFilter(filter)) this.isVerifiedIsSet = false;

    if (!this.isBadApplyFilter(filter)) this.isBadIsSet = false;

    if (!this.assignIdApplyFilter(filter)) this.assignIdIsSet = false;

    if (!this.personAddressAssignIdApplyFilter(filter))
      this.personAddressAssignIdIsSet = false;

    if (!this.startActiveApplyFilter(filter)) this.startActiveIsSet = false;

    if (!this.endActiveApplyFilter(filter)) this.endActiveIsSet = false;

    if (!this.nameApplyFilter(filter)) this.nameIsSet = false;

    if (!this.isPrimaryApplyFilter(filter)) this.isPrimaryIsSet = false;

    return this;
  }
  isDeletedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      AddressDTOMeta.isDeleted,
      AddressDTOMeta,
      this.isDeleted,
      this,
    );
  }
  isDeletedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isDeletedIsSet && this.isDeletedApplyFilter(filter)) return true;

    return false;
  }
  isNewApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(AddressDTOMeta.isNew, AddressDTOMeta, this.isNew, this);
  }
  isNewIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isNewIsSet && this.isNewApplyFilter(filter)) return true;

    return false;
  }
  line1ApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(AddressDTOMeta.line1, AddressDTOMeta, this.line1, this);
  }
  line1IsSetDeep(filter?: FilterVarsType): boolean {
    if (this.line1IsSet && this.line1ApplyFilter(filter)) return true;

    return false;
  }
  line2ApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(AddressDTOMeta.line2, AddressDTOMeta, this.line2, this);
  }
  line2IsSetDeep(filter?: FilterVarsType): boolean {
    if (this.line2IsSet && this.line2ApplyFilter(filter)) return true;

    return false;
  }
  line3ApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(AddressDTOMeta.line3, AddressDTOMeta, this.line3, this);
  }
  line3IsSetDeep(filter?: FilterVarsType): boolean {
    if (this.line3IsSet && this.line3ApplyFilter(filter)) return true;

    return false;
  }
  stateApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(AddressDTOMeta.state, AddressDTOMeta, this.state, this);
  }
  stateIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.stateIsSet && this.stateApplyFilter(filter)) return true;

    return false;
  }
  cityApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(AddressDTOMeta.city, AddressDTOMeta, this.city, this);
  }
  cityIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.cityIsSet && this.cityApplyFilter(filter)) return true;

    return false;
  }
  countryApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(AddressDTOMeta.country, AddressDTOMeta, this.country, this);
  }
  countryIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.countryIsSet && this.countryApplyFilter(filter)) return true;

    return false;
  }
  zipApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(AddressDTOMeta.zip, AddressDTOMeta, this.zip, this);
  }
  zipIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.zipIsSet && this.zipApplyFilter(filter)) return true;

    return false;
  }
  isVerifiedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      AddressDTOMeta.isVerified,
      AddressDTOMeta,
      this.isVerified,
      this,
    );
  }
  isVerifiedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isVerifiedIsSet && this.isVerifiedApplyFilter(filter)) return true;

    return false;
  }
  isBadApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(AddressDTOMeta.isBad, AddressDTOMeta, this.isBad, this);
  }
  isBadIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isBadIsSet && this.isBadApplyFilter(filter)) return true;

    return false;
  }
  assignIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(AddressDTOMeta.assignId, AddressDTOMeta, this.assignId, this);
  }
  assignIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.assignIdIsSet && this.assignIdApplyFilter(filter)) return true;

    return false;
  }
  personAddressAssignIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      AddressDTOMeta.personAddressAssignId,
      AddressDTOMeta,
      this.personAddressAssignId,
      this,
    );
  }
  personAddressAssignIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.personAddressAssignIdIsSet &&
      this.personAddressAssignIdApplyFilter(filter)
    )
      return true;

    return false;
  }
  startActiveApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      AddressDTOMeta.startActive,
      AddressDTOMeta,
      this.startActive,
      this,
    );
  }
  startActiveIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.startActiveIsSet && this.startActiveApplyFilter(filter))
      return true;

    return false;
  }
  endActiveApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      AddressDTOMeta.endActive,
      AddressDTOMeta,
      this.endActive,
      this,
    );
  }
  endActiveIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.endActiveIsSet && this.endActiveApplyFilter(filter)) return true;

    return false;
  }
  nameApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(AddressDTOMeta.name, AddressDTOMeta, this.name, this);
  }
  nameIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.nameIsSet && this.nameApplyFilter(filter)) return true;

    return false;
  }
  isPrimaryApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      AddressDTOMeta.isPrimary,
      AddressDTOMeta,
      this.isPrimary,
      this,
    );
  }
  isPrimaryIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isPrimaryIsSet && this.isPrimaryApplyFilter(filter)) return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.isDeletedIsSetDeep(filter)) return true;
    if (this.isNewIsSetDeep(filter)) return true;
    if (this.line1IsSetDeep(filter)) return true;
    if (this.line2IsSetDeep(filter)) return true;
    if (this.line3IsSetDeep(filter)) return true;
    if (this.stateIsSetDeep(filter)) return true;
    if (this.cityIsSetDeep(filter)) return true;
    if (this.countryIsSetDeep(filter)) return true;
    if (this.zipIsSetDeep(filter)) return true;
    if (this.isVerifiedIsSetDeep(filter)) return true;
    if (this.isBadIsSetDeep(filter)) return true;
    if (this.assignIdIsSetDeep(filter)) return true;
    if (this.personAddressAssignIdIsSetDeep(filter)) return true;
    if (this.startActiveIsSetDeep(filter)) return true;
    if (this.endActiveIsSetDeep(filter)) return true;
    if (this.nameIsSetDeep(filter)) return true;
    if (this.isPrimaryIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
